import React, { useState } from "react";
import DataTable from "Common/DataTable/DataTable";
import useTableConfig from "Hooks/useTableConfig";
import { useRoleVerify } from "Common/RoleVerify";
import usePaginatedFetch from "Hooks/usePaginatedFetch";
import { getAssignedRosterList,DeleteRoster } from "adminApi/DutyRosterApi/AssignedRosterApi";
import fieldsJson from "../../json/AssignRosterFields.json";
import { generateDisplayFields } from "utils/fieldMapper";
import useDebouncedValue from "Common/DataTable/useDebouncedValue";

const RosterAssignedTable = () => {
    const tabledata = fieldsJson.tabledata;
    const [search, setSearch] = useState("");
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(1);
    const debouncedSearch = useDebouncedValue(search, 500);
    const canShowAction = useRoleVerify("", ["can_edit", "can_delete"]);
    const sizeOptions = [10, 20, 50, 100];


    const { data, meta, loading, error, refetch } = usePaginatedFetch(getAssignedRosterList, {
        page,
        limit,
        search: debouncedSearch,
        title: "Assigned Employee",
    });

    const displayFields = generateDisplayFields(tabledata);

    const { columns, formattedData } = useTableConfig({
        data: data || [],
        page,
        limit,
        canShowAction,
        refetch,
        isView: true,
        config: {
            entityName: "Assigned Employee",
            editUrl: "edit-roster-assignment",
            ViewUrl: "view-roster-assignment",
            idKey: "roster_id",
            displayFields,
            deleteApi:DeleteRoster,
        },
    });

    const handleSearch = (val, resetPage = null) => {
        setSearch(val);
        if (resetPage !== null) setPage(resetPage);
    };

    const onPageChange = (p) => { setPage(p) };

    const onLimitChange = (newLimit) => {
        setLimit(newLimit);
        setPage(1);
    };

    return (
        <DataTable
            columns={columns}
            data={formattedData}
            options={{
                loading,
                error,
                sortableColumns: displayFields.map((f) => f.accessor),
                copy: true,
                csv: true,
                pdf: true,
                print: true,
                fileName: "Assigned Roster",
            }}
            Search={{
                search: true,
                SearchInputValue: search,
                handleSearch: handleSearch,
            }}
            Entries={{
                Entries: true,
                limit,
                onLimitChange,
                options: sizeOptions,
            }}
            pagination={{
                isActive: true,
                meta,
                onPageChange,
            }}
        />
    );
};

export default RosterAssignedTable;
